var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-facebook-integration-card"},[(_vm.data.image)?_c('ui-image',{attrs:{"src":_vm.data.image,"alt":_vm.data.name,"h":"50","w":"50"}}):_c('div',{staticClass:"fac-image"}),(_vm.data.name)?_c('div',{staticClass:"ui-facebook-integration-card-title"},[_vm._v(_vm._s(_vm.data.name))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }